export const GS_KEEP_MINIFIED_SEARCH_OPEN = 'GS_KEEP_MINIFIED_SEARCH_OPEN';
export const GLOBAL_SEARCH_QUERY_PARAM = 'globalSearchQuery';
export const GLOBAL_SEARCH_FULL_PAGE_SEARCH_QUERY_PARAM = 'query';
export const POST_MESSAGE_ROOT_KEY = 'global_search';
export function handleError(err) {
  setTimeout(() => {
    throw err;
  });
}
export const SEARCH_TRACKING_CONSTANTS = {
  OPEN: 'open',
  CLOSE: 'close',
  NAVIGATE_RESULT: 'navigate',
  SELECT: 'select',
  ENTER: 'enter',
  MOUSE: 'mouse',
  KEYBOARD: 'keyboard',
  ESCAPE: 'escape'
};
export const SEARCH_INPUT_MIN_WIDTH = '230px';
export const LEGACY_SEARCH_INPUT_MIN_WIDTH = '170px';
export const SEARCH_INPUT_SHORTCUT_HINT_WIDTH = '64px';
export const GLOBAL_SEARCH_CUSTOM_EVENT = 'globalsearchevent';
export const SEARCH_IFRAME_OFFSET_TOP = 6;
export const SEARCH_IFRAME_OFFSET_BOTTOM = 6;